<template>

  <div style="margin-left: 20px">

    <div class="img-container">
      <el-image style="width: 100%; height: 100%; border-radius: 5px"
                :src="require('@/assets/images/home/'+imageName+'.png')" fit="fill">
      </el-image>

      <div class="title-container">

        <div class="en-title">
          {{englishStr.slice(0,1)}}
        </div>

        <div class="label-container">
          <div class="ch-label">
            {{chineseStr}}
          </div>

          <div class="en-label">
            {{englishStr.slice(1)}}
          </div>
        </div>

      </div>

    </div>

    <div>
      <div style="margin-top: 1em" v-for="(item) in tags" :key="item.path">

        <el-button style="width: 220px;padding-left: 0px;padding-right: 0px" @click="pushPage(item)"  :type="$route.path===item.path?'primary':''">{{item.name}}</el-button>

      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'TitleTagsAside',
  props: {
    imageName: String, // 图片名称
    chineseStr: String, // 中文名称
    englishStr: String, // 英文名称
    tags: Array
  },
  methods: {
    init () {
      for (var i = 0; i < this.tags.length; i++) {
        var item = this.tags[i]

        if (this.$route.path === item.path) {
          console.log(item.name)
          this.$emit('chooseitem', {name: item.name})
        }
      }
    },
    pushPage (item) {
      if (item.path === this.$route.path) {
        return
      }
      this.$emit('chooseitem', {name: item.name})

      if (item.path === '/study/practice') {
        window.open('http://192.168.1.4/ksxt/index.html#/student/login')
      } else {
        this.$router.push(item.path)
      }
    }
  },
  beforeUpdate () {
    this.init()
  }
}
</script>

<style scoped>

.title-container{
  position: absolute;
  top: 22px;
  left: 0px;
  height: 76px;
  width: 220px;
  margin: 0 auto;
}

.img-container{
  width: 220px;
  height: 120px;
  position: relative
}

.label-container{
  display: inline-block;
  margin-left: 5px
}

.en-title{
  display: inline-block;
  font-size: 50px;
  color: #0155D1;
  margin-left: 25px
}

.ch-label{
  color: white;
}

.en-label{
  color: #0155D1;
  margin-top: 5px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/pc/widgets/TitleTagsAside.vue